// src/pages/Welcome.jsx
import { useTranslation } from "react-i18next";
import priceIcon from "../assets/icons/price.svg";

import CopyButton from "../components/CopyButton";
import { timeSince } from "../utils/timeSince";
import PreviousSectionCard from "../components/PreviousSectionCard";

const Pricing = () => {
  const { t, i18n } = useTranslation();

  const lastUpdated = "2025-12-05";
  const lang = i18n.language;

  const buildCopyText = (t) => {
    return ""
  };

  return (
    <div className="text-black dark:text-white">
      <div
        className="
          desktop:px-4
          max-w-3xl
        "
      >
        {/* Header + copy */}
        <div className="
  relative flex items-center justify-between gap-3
  mobile:flex-col
  mobile:items-stretch
  desktop:flex-row-reverse
  tabletpro:flex-row-reverse
  tabletair:flex-row-reverse
  tabletmini:flex-row-reverse
  mini_mobile:flex-col mini_mobile:items-stretch
">
          {/* Copy button */}
          <div className="mobile:flex mobile:justify-end mobile:order-1 mini_mobile:flex mini_mobile:justify-end">
            <CopyButton text={buildCopyText(t)} />
          </div>

          {/* Icon + text */}
          <div className="flex items-center gap-3 mobile:order-2">
            <img
              src={priceIcon}
              alt="price"
              className="w-9 h-9"
            />
            <h1 className="text-[#020617] dark:text-[#F8FAFC] text-[40px]  tabletpro:text-[28px] mobile:text-[28px] mini_mobile:text-[24px] font-semibold">
              {t("sidebar.pricing")}
            </h1>
          </div>
        </div>


        {/* Nội dung chính */}
        <div className="mt-2 relative space-y-6 text-sm">
          <section className='flex gap-4 mt-1'>
            <p className='text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]'>{t("common.comingsoon")}</p>
          </section>

          {/* Next section card */}
          <section>
            <PreviousSectionCard
              label={t("sidebar.cases.acrobatReader")}
              to="/cases/acrobat-reader"
            />
          </section>

          {/* Last updated */}
          <section>
            <span className="text-[14px] text-[#64748B]">
              {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
            </span>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Pricing;
